import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpConstants } from '../constants/http-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  private apiAuth = HttpConstants.API_AUTH;

  constructor(private http: HttpClient) {}

  public authorizeUser() {
    const headers = new HttpHeaders({
      'Content-Type': HttpConstants.ALL_TYPES_HEADER
    });
    return this.http.post(this.apiAuth, '', {
      headers: headers,
      observe: 'response',
      withCredentials: true
    });
  }

  public getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }

    return null;
  }
}
